import { MaintenanceForwardingsDirectiveEntryKlass } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsDirectiveEntryKlasses.type'
import { MaintenanceDirectiveObjectiveData } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/types/maintenanceForwarding.type'
import { useForwardingTabContext } from '@/features/maintenanceWorkflow/pages/Show/hooks/forwardings/useForwardingTabContext'
import { useMemo } from 'react'

const useGetDirectiveEntryObjectivesSummary = () => {
  const { forwarding, forwardingUpdatedAt, directiveEntryKlass } = useForwardingTabContext()

  return useMemo(() => {
    let piecesCount = 0
    let activitiesCount = 0

    let piecesKey: keyof MaintenanceDirectiveObjectiveData = 'diagnostic_pieces'
    let activitiesKey: keyof MaintenanceDirectiveObjectiveData = 'diagnostic_activities'

    if (directiveEntryKlass === MaintenanceForwardingsDirectiveEntryKlass.ExecutionEntry) {
      piecesKey = 'execution_pieces'
      activitiesKey = 'execution_activities'
    }

    const piecesTotalValue = forwarding?.directive_entry?.objectives?.reduce((prev, curr) => {
      return (
        prev +
        ((curr[piecesKey] as { total_value: string }[])?.reduce((prevB, currB) => {
          piecesCount += 1

          return prevB + parseFloat(currB.total_value)
        }, 0) || 0)
      )
    }, 0)

    const activitiesTotalValue = forwarding?.directive_entry?.objectives?.reduce((prev, curr) => {
      return (
        prev +
        ((curr[activitiesKey] as { total_value: string }[])?.reduce((prevB, currB) => {
          activitiesCount += 1

          return prevB + parseFloat(currB.total_value)
        }, 0) || 0)
      )
    }, 0)

    let piecesCountDisplay: string

    if (piecesCount === 0) piecesCountDisplay = 'Nenhuma peça'
    else if (piecesCount === 1) piecesCountDisplay = '1 Peça'
    else piecesCountDisplay = `${piecesCount} Peças`

    let activitiesCountDisplay: string

    if (activitiesCount === 0) activitiesCountDisplay = 'Nenhum serviço'
    else if (activitiesCount === 1) activitiesCountDisplay = '1 Serviço'
    else activitiesCountDisplay = `${activitiesCount} Serviços`

    return {
      piecesCount,
      piecesCountDisplay,
      piecesTotalValue,
      activitiesCount,
      activitiesCountDisplay,
      activitiesTotalValue,
    }
  }, [forwardingUpdatedAt])
}

export default useGetDirectiveEntryObjectivesSummary
